export const heroSection = {
  title: "AI Recruiters That Hire Humans",
  subtitle:
    "BabbleBots AI interviews and engages every candidate. Shortlists the best. Humans close \u2014 10x faster.",
  description: "Across video, phone, code, and WhatsApp \u2014 24/7.",
  cta1: {
    text: "Start Free Trial Today",
    link: "https://app.babblebots.ai",
  },
  cta2: {
    text: "Request a Demo",
    link: "https://calendly.com/sales-babblebots/babblebots-discovery",
  },
};

export const hearFromCustomer = {
  title: "Customers Testimonials",
  description:
    "Testimonials about how AI-Recruiters Help with Speed and Quality of Hiring.",
};

export const videoData = [
  {
    id: "1eDC9B8snUI",
    title: "Atrina Testimonial",
    testimonial:
      '"Hiring with AI Recruiter is much quicker; you don\'t have to spend a lot of time only hiring - you can invest your time in other work as well."',
    author: {
      name: "Ruchi Gupta",
      company: "Atrina Technologies",
      designation: "Head of TA & People Analytics",
    },
  },
  {
    id: "zc4a4wS4vAw",
    title: "Welspun Testimonial",
    testimonial:
      "\"Babblebots has helped us save time, reduce costs, and most importantly, improve the quality of our hires. It's been a game-changer for us, and we're eager to explore further partnerships and integrations in the future.\"",
    author: {
      name: "Rajesh Jain",
      company: "Welspun Enterprises",
      designation: "Chief HR officer",
    },
  },
  {
    id: "RdEVCm9PHZI",
    title: "Ajmera Testimonial",
    testimonial:
      "\"Babblebots has eased our hiring life cycle a lot and I would say that, you know, it's effective. I like Babblebot's unique proposition that it is able to use a combined language of a national language Hindi and the global language English.\"",
    author: {
      name: "Shweta Rathor",
      company: "Ajmera Realty",
      designation: "GM Human Resources",
    },
  },
];

export const section3Text = [
  "Leaders Need To Recruit The Best Teams.",
  <p>
    AI Helps Humans <br /> Hire The Top Talent Fast <br />& with Data-driven
    Confidence.
  </p>,
];
